export default __webpack_public_path__ + "static/media/TESTIMONI-YESI FITRI.49ce9376.jpg";